var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8711 3.423V14.385C16.8711 14.845 16.7171 15.229 16.4091 15.537C16.1004 15.8457 15.7161 16 15.2561 16H2.48609C2.02609 16 1.64209 15.846 1.33409 15.538C1.02543 15.2293 0.871094 14.845 0.871094 14.385V1.615C0.871094 1.155 1.02543 0.771 1.33409 0.463C1.64209 0.154333 2.02609 0 2.48609 0H13.4481L16.8711 3.423ZM8.86609 12.538C9.42076 12.538 9.89343 12.344 10.2841 11.956C10.6754 11.568 10.8711 11.097 10.8711 10.543C10.8711 9.989 10.6771 9.51633 10.2891 9.125C9.90109 8.73367 9.43009 8.538 8.87609 8.538C8.32209 8.538 7.84943 8.732 7.45809 9.12C7.06676 9.50867 6.87109 9.98 6.87109 10.534C6.87109 11.088 7.06509 11.5607 7.45309 11.952C7.84109 12.3427 8.31209 12.538 8.86609 12.538ZM3.64109 5.77H11.0641V2.77H3.64109V5.77Z",
    fill: "#FF671D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.9642981c347df59e0829cc2dee7ef6c6.svg";
export { ForwardRef as ReactComponent };